import { TestVariantProps } from '@/lib/ab-tests/types'

//Do not reuse indices for different tests, Maximum index id TEST_VARIANTS_COOKIE_LENGTH - 1
//After reaching the maximum index, then start over again.
export enum TestVariant {
  // ReloadSavedSearchData = 0,
  // DirectlyBookable = 1,
  // XTimesTagged = 2,
  // SearchFilterAtBottom = 3,
  HideFlexibleTravelPeriod = 4,
  NewBookingPage = 5,
  TopBox = 6,
  HotelFocus = 7,
  MandatoryStars = 8,
  NoTravelersOnRequest = 9,
  SmallCommentBox = 10,
  NoTat = 11,
  NoHotelBox = 12,
  NoTotalPrice = 13,
  MovedTrustIcons = 14,
  HidePayMessage = 15,
}

export enum UserParameterSlot {
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Five = '5',
  Six = '6',
  Seven = '7',
  Eight = '8',
  Nine = '9',
  Ten = '10',
  Eleven = '11',
  Twelve = '12',
  Thirteen = '13',
  Fourteen = '14',
  Fifteen = '15',
  Sixteen = '16',
  Seventeen = '17',
  Eighteen = '18',
}

export enum Split {
  FiftyFifty = 5,
  TwentyEighty = 2,
  ZeroHundred = 0,
  HundredZero = 10,
}

export enum Splits {
  Twenty = 2,
  Fourty = 4,
  Fifty = 5,
  Eighty = 8,
  Zero = 0,
  Hundred = 10,
}
export enum TestGroup {
  A,
  B,
  C,
}

type TestVariants = Record<TestVariant, TestVariantProps>

export const TEST_VARIANTS_PROPS: TestVariants = {
  // [TestVariant.ReloadSavedSearchData]: {
  //   enabled: true,
  //   serverSide: false,
  //   groupLogic: TestVariantGroupLogic.EVEN_ODD,
  //   name: 'reloadsavedsearchdata',
  //   slot: UserParameterSlot.One,
  //   split: Split.FiftyFifty,
  // },
  // [TestVariant.DirectlyBookable]: {
  //   enabled: true,
  //   serverSide: false,
  //   groupLogic: TestVariantGroupLogic.FIRST_HALF_SECOND_HALF,
  //   name: 'directlybookable',
  //   slot: UserParameterSlot.Two,
  //   split: Split.FiftyFifty,
  // },
  // [TestVariant.XTimesTagged]: {
  //   enabled: true,
  //   serverSide: false,
  //   name: 'xtimestagged',
  //   slot: UserParameterSlot.Three,
  //   split: Split.FiftyFifty,
  // },
  // [TestVariant.SearchFilterAtBottom]: {
  //   enabled: true,
  //   serverSide: false,
  //   name: 'searchfilteratbottom',
  //   slot: UserParameterSlot.Four,
  //   split: Split.FiftyFifty,
  // },
  [TestVariant.HideFlexibleTravelPeriod]: {
    enabled: true,
    serverSide: false,
    name: 'new-booking-page-hide-flexible-travel-period',
    slot: UserParameterSlot.Five,
    split: Split.ZeroHundred,
  },
  [TestVariant.NewBookingPage]: {
    enabled: true,
    serverSide: false,
    name: 'new-booking-page',
    slot: UserParameterSlot.Six,
    splits: [Splits.Twenty, Splits.Eighty],
  },
  [TestVariant.TopBox]: {
    enabled: true,
    serverSide: true,
    pathPrefix: '/checkout',
    name: 'new-booking-page-top-box',
    slot: UserParameterSlot.Seven,
    splits: [Splits.Fifty, Splits.Fifty],
  },
  [TestVariant.HotelFocus]: {
    enabled: true,
    serverSide: false,
    name: 'new-booking-page-hotel-focus',
    slot: UserParameterSlot.Eight,
    splits: [Splits.Fifty, Splits.Fifty],
  },
  [TestVariant.MandatoryStars]: {
    enabled: true,
    serverSide: false,
    name: 'new-booking-page-mandatory-stars',
    slot: UserParameterSlot.Nine,
    splits: [Splits.Fifty, Splits.Fifty],
  },
  [TestVariant.NoTravelersOnRequest]: {
    enabled: true,
    serverSide: false,
    name: 'new-booking-page-no-travelers-on-request',
    slot: UserParameterSlot.Ten,
    splits: [Splits.Fifty, Splits.Fifty],
  },
  [TestVariant.SmallCommentBox]: {
    enabled: true,
    serverSide: false,
    name: 'new-booking-page-small-comment-box',
    slot: UserParameterSlot.Eleven,
    splits: [Splits.Fifty, Splits.Fifty],
  },
  [TestVariant.NoTat]: {
    enabled: true,
    serverSide: false,
    name: 'new-booking-page-no-tat',
    slot: UserParameterSlot.Twelve,
    splits: [Splits.Fifty, Splits.Fifty],
  },
  [TestVariant.NoHotelBox]: {
    enabled: true,
    serverSide: false,
    name: 'new-booking-page-no-hotel-box',
    slot: UserParameterSlot.Thirteen,
    splits: [Splits.Fifty, Splits.Fifty],
  },
  [TestVariant.NoTotalPrice]: {
    enabled: true,
    serverSide: false,
    name: 'new-booking-page-no-additional-price',
    slot: UserParameterSlot.Fourteen,
    splits: [Splits.Fifty, Splits.Fifty],
  },
  [TestVariant.MovedTrustIcons]: {
    enabled: true,
    serverSide: true,
    pathPrefix: '/checkout',
    name: 'new-booking-page-moved-trust-icons',
    slot: UserParameterSlot.Fifteen,
    splits: [Splits.Fifty, Splits.Fifty],
  },
  [TestVariant.HidePayMessage]: {
    enabled: true,
    serverSide: false,
    name: 'new-booking-page-hide-pay-info',
    slot: UserParameterSlot.Sixteen,
    splits: [Splits.Twenty, Splits.Fourty, Splits.Fourty],
  },
}
